import { formatDate } from "../../../../utils/dateFormat";

export const ARRIVAL_ONBOARDING_COLUMNS = [
  { key: 'serial', title: 'SL NO.', searchable: false },
  { key: 'flight_icon', title: 'FLIGHT ICON', searchable: false },
  { key: 'flight_details', title: 'FLIGHT DETAILS', searchable: true },
  { key: 'country', title: 'COUNTRY', searchable: true },
  { key: 'pax', title: 'PAX', searchable: false },
  { key: 'date_of_arrival', title: 'DATE OF ARRIVAL', searchable: false, render: formatDate },
  { key: 'time_of_arrival', title: 'TIME OF ARRIVAL', searchable: false },
  { key: 'sector_name', title: 'ARRIVAL SECTOR', searchable: true },
  { key: 'pickup_to_be_arranged', title: 'PICKUP TO BE ARRANGED', searchable: false },
  { key: 'project_incharge', title: 'PROJECT INCHARGE', searchable: true },
  { key: 'client_name', title: 'CLIENT NAME', searchable: true },
  { key: 'flight_status', title: 'FLIGHT STATUS', searchable: true },
  // { key: 'action', title: 'ACTION', searchable: false },
];

export const ARRIVAL_ONBOARDING_CONFIG = {
  API_ENDPOINT: "/dashboard/arrival-onboarding",
  SEARCH_PLACEHOLDER: "Search flights...",
  NO_DATA_MESSAGE: "No arrival onboarding data found",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000],
};

export const ARRIVAL_ONBOARDING_SEARCHABLE_FIELDS = ARRIVAL_ONBOARDING_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);
